import "../sass/main.scss"

import GoogleMap from "./modules/GoogleMap"
import Search from "./modules/Search"
import Slider from "./modules/Slider"
import MyNotes from "./modules/MyNotes"
import Like from "./modules/Like"

const googleMap = new GoogleMap()
const search = new Search()
const slide = new Slider()
const myNotes = new MyNotes()
const like = new Like()